import { ziggyUnsafe } from "@solvari/common-fe/integrations";
import { ky, toSearchParams } from "@solvari/utils";

type QueryWrapper<Result> = (
  callback: () => Promise<Result>,
) => () => Promise<Result>;

function useGeoProductCategories(
  params: App.DTO.Geo.GeoProductCategoriesRequestDTO,
  queryWrapper: QueryWrapper<App.DTO.Geo.GeoProductCategoryDTO[]>,
) {
  return {
    key: () => ["api.v3.main-site.geoProductCategories", params] as const,
    query: queryWrapper(() => {
      return ky
        .get(ziggyUnsafe("api.v3.main-site.geoProductCategories"), {
          searchParams: toSearchParams(params),
        })
        .json<App.DTO.Geo.GeoProductCategoryDTO[]>();
    }),
    staleTime: Infinity,
  };
}

function useProvinces(
  params: App.DTO.Geo.ProvincesRequestDTO,
  queryWrapper: QueryWrapper<App.DTO.Geo.ProvinceDTO[]>,
) {
  return {
    key: () => ["api.v3.geo.provinces", params] as const,
    query: queryWrapper(() => {
      return ky
        .get(ziggyUnsafe("api.v3.geo.provinces"), {
          searchParams: toSearchParams(params),
        })
        .json<App.DTO.Geo.ProvinceDTO[]>();
    }),
    staleTime: Infinity,
  };
}

export type { QueryWrapper };
export { useGeoProductCategories, useProvinces };
